import * as DictionaryConstants from "../../../../../../constants/DictionaryConstants";
import * as RoutePathConstants from "../../../../../../constants/RoutePathConstants";
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl';
import http from '../../../../../../common/utils/http';
import moment from 'moment'

export default {
  data () {
    return {
      memberDetails: {},
      memberStoredValueRecordingPageList: [],
      centerHeight: document.documentElement.clientHeight - 260 + "px",
    };
  },
  methods: {
    cxmx () {
      this.$router.push({
        path: RoutePathConstants.CAR_WASH_SERVICE,
        query: { isShow: "cxmx" }
      });
    },
    ljcz () {
      this.$router.push({
        path: RoutePathConstants.CAR_WASH_SERVICE,
        query: { isShow: "ljcz" }
      });
    },
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`)
        .then(res => {
          this.memberDetails = res.data.data;
          this.qrCode = `${API_BASE_URL}/api/qr/generate?content=${res.data.data.id
            }&X-Authorization=${localStorage.getItem("token")}`;
        });
    },
    dateFormate (time) {
      return time ? moment(time).format('YYYY-MM-DD') : '-'
    },
    getMemberStoredValueRecordingPageList () {
      http
        .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getMemberStoredValueRecordingPageList?pageNum=1&pageSize=200`)
        .then(res => {
          this.memberStoredValueRecordingPageList = res.data.data.dataList
        });
    },
    goToDetails (item) {
      this.$router.push({
        path: RoutePathConstants.STORED_VALUE_WALLET_INFO,
        query: {
          info: item
        }
      })
    }
  },
  mounted () {
    document.title = '我的储值'
    this.getMemberDetails()
    this.getMemberStoredValueRecordingPageList()
  }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-my/views/stored-value-wallet/stored-value-wallet.js